export var Node_Type;
(function (Node_Type) {
    Node_Type["PARAGRAPH"] = "PARAGRAPH";
    Node_Type["TEXT"] = "TEXT";
    Node_Type["HEADING"] = "HEADING";
    Node_Type["BULLETED_LIST"] = "BULLETED_LIST";
    Node_Type["ORDERED_LIST"] = "ORDERED_LIST";
    Node_Type["LIST_ITEM"] = "LIST_ITEM";
    Node_Type["BLOCKQUOTE"] = "BLOCKQUOTE";
    Node_Type["CODE_BLOCK"] = "CODE_BLOCK";
    Node_Type["VIDEO"] = "VIDEO";
    Node_Type["DIVIDER"] = "DIVIDER";
    Node_Type["FILE"] = "FILE";
    Node_Type["GALLERY"] = "GALLERY";
    Node_Type["GIF"] = "GIF";
    Node_Type["HTML"] = "HTML";
    Node_Type["IMAGE"] = "IMAGE";
    Node_Type["LINK_PREVIEW"] = "LINK_PREVIEW";
    Node_Type["MAP"] = "MAP";
    Node_Type["POLL"] = "POLL";
    Node_Type["APP_EMBED"] = "APP_EMBED";
    Node_Type["BUTTON"] = "BUTTON";
    Node_Type["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    Node_Type["TABLE"] = "TABLE";
    Node_Type["EMBED"] = "EMBED";
    Node_Type["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    Node_Type["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    Node_Type["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    Node_Type["TABLE_CELL"] = "TABLE_CELL";
    Node_Type["TABLE_ROW"] = "TABLE_ROW";
    Node_Type["EXTERNAL"] = "EXTERNAL";
    Node_Type["AUDIO"] = "AUDIO";
    Node_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Node_Type || (Node_Type = {}));
export var Decoration_Type;
(function (Decoration_Type) {
    Decoration_Type["BOLD"] = "BOLD";
    Decoration_Type["ITALIC"] = "ITALIC";
    Decoration_Type["UNDERLINE"] = "UNDERLINE";
    Decoration_Type["SPOILER"] = "SPOILER";
    Decoration_Type["ANCHOR"] = "ANCHOR";
    Decoration_Type["MENTION"] = "MENTION";
    Decoration_Type["LINK"] = "LINK";
    Decoration_Type["COLOR"] = "COLOR";
    Decoration_Type["FONT_SIZE"] = "FONT_SIZE";
    Decoration_Type["EXTERNAL"] = "EXTERNAL";
    Decoration_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Decoration_Type || (Decoration_Type = {}));
//# sourceMappingURL=rich_content.enums.js.map